import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form/dist/index.ie11";
import Button from "~/shared/ui/Fields/Button";
import s from "./styles.less";
import {
  useAddNotificationMutation,
  useSetGuideFileMutation,
} from "~/schemas/generated/graphql";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FileLoader from "~/components/FileLoader";
import { NOTIFICATIONS } from "~/constans/notifications";
import { usePermissions } from "~/shared/context/PermissionContext";

interface IProps {
  setCloseModal?: () => void;
  refetch?;
  guideFile?;
}

const ManagementForm: FC<IProps> = ({ setCloseModal, refetch, guideFile }) => {
  const { t } = useTranslation();
  const [addNotificationMutation] = useAddNotificationMutation({});
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const { AdminFileId, AdminFile, UserFileId, UserFile } = guideFile;

  const [createReport] = useSetGuideFileMutation({
    onCompleted() {
      refetch();
      setCloseModal();
    },
    onError({ graphQLErrors, networkError }) {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.error,
          content: ` ${t(
            `errors.${graphQLErrors[0]["extensions"]["code"]}_period`
          )}`,
        },
      });
    },
  });
  const [clearReport] = useSetGuideFileMutation({
    onCompleted() {
      refetch();
    },
    onError({ graphQLErrors, networkError }) {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.error,
          content: ` ${t(
            `errors.${graphQLErrors[0]["extensions"]["code"]}_period`
          )}`,
        },
      });
    },
  });

  const schema = yup.object().shape({});

  const { handleSubmit, control, watch, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    createReport({
      variables: {
        AdminFileId: data.AdminFile,
        UserFileId: data.UserFile,
      },
    });
  };

  const onClearUser = () => {
    clearReport({
      variables: {
        UserFileId: null,
      },
    });
  };

  const onClearAdmin = () => {
    clearReport({
      variables: {
        AdminFileId: null,
      },
    });
  };

  return (
    <form className={s.form} onSubmit={handleSubmit(onSubmit)}>
      <ul>
        <li>
          <FileLoader
            withButton
            titleDownload={"Руководство администратора"}
            label={"Руководство администратора"}
            name={"AdminFile"}
            download={AdminFile}
            accept={".pdf, .docx"}
            deleteFile={onClearAdmin}
            control={control}
            setValue={setValue}
          />
        </li>
        <li>
          <FileLoader
            withButton
            titleDownload={"Руководство пользователя"}
            label={"Руководство пользователя"}
            name={"UserFile"}
            download={UserFile}
            accept={".pdf, .docx"}
            deleteFile={onClearUser}
            control={control}
            setValue={setValue}
          />
        </li>
      </ul>

      {hasPermission("user_guides.setGuideFile") && (
        <div className={s.btns}>
          <Button txtBtn={t("ui.save")} isForm />
          <Button txtBtn={t("ui.close")} empty onClick={setCloseModal} />
        </div>
      )}
    </form>
  );
};
export default ManagementForm;
